(function () {

  /* =========================================================
     Sterntaler – Pflegehinweise (PDP-Akkordeon "Infos & Pflege")

     - Reihenfolge immer nach ISO 3758 / GINETEX:
       1 Waschen, 2 Bleichen, 3 Trocknen, 4 Bügeln, 5 Professionelle Pflege,
       danach alle sonstigen Hinweise in Originalreihenfolge.
     - Darstellung über Theme-Einstellungen > "Pflegehinweise":
       text        = nur Text (Standard)
       icons_text  = Symbole in einer durchgehenden Reihe + Text
       icons       = nur Symbole
  ========================================================= */

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[m];
    });
  }

  function iconByKey(key) {
    return (window.__careIcons && window.__careIcons[key]) || "";
  }

  function displayMode() {
    var mode = window.__careDisplay;
    return mode === "icons" || mode === "icons_text" ? mode : "text";
  }

  /* =========================================================
     Icon Mapping
  ========================================================= */

  function getIconKey(label) {
    var k = label.toLowerCase();
    var has = function (s) { return k.indexOf(s) !== -1; };

    /* Waschen */
    if (has("nicht waschen")) return "noWash";
    if (has("handwäsche") || has("handwaesche")) return "handwash";
    if (has("spezialschonwaschgang") || has("wolle")) return has("30") ? "washVeryDelicate30" : "washText";
    if (has("schonwaschgang") || has("feinwaschgang")) return has("30") ? "washDelicate30" : "washText";
    if (has("normalwaschgang 30") || has("waschen 30") || has("30 °c") || has("30°")) return "wash30";
    if (has("normalwaschgang 40") || has("waschen 40") || has("40 °c") || has("40°")) return "wash40";
    if (has("normalwaschgang 60") || has("waschen 60") || has("60 °c") || has("60°")) return "wash60";
    if (has("95")) return "wash95";
    if (has("normalwaschgang 90") || has("90 °c") || has("90°")) return "washText"; /* kein GINETEX-Symbol für 90 °C */

    /* Bleichen */
    if (has("nicht bleichen")) return "noBleach";
    if (has("bleiche zulässig") || has("bleichen möglich")) return "bleach";

    /* Trocknen */
    if (has("trockner") && has("nicht")) return "noTumble";
    if (has("nicht trocknen")) return "noTumble";
    if ((has("trock")) && (has("niedrig") || has("schonend"))) return "tumbleLow";
    if ((has("trock")) && has("normal")) return "tumbleNormal";
    if (has("trockner") || has("trocknen möglich")) return "tumble";

    /* Bügeln */
    if (has("nicht bügeln") || has("nicht bugeln")) return "noIron";
    if (has("110") || has("nicht heiß bügeln") || has("warm bügeln") || has("warm bugeln")) return "iron110";
    if (has("200") || has("250")) return "iron200";
    if (has("150") || has("mäßig") || has("heiß bügeln") || has("heiss bugeln")) return "iron150";

    /* Professionelle Pflege */
    if (has("chemische reinigung nicht") || has("nicht für chemische") || has("nicht chemisch")) return "noDryclean";
    if (has("schonende chemische")) return "drycleanGentle";
    if (has("chemische reinigung möglich") || has("chemisch reinigen")) return "dryclean";

    /* Sonstiges */
    if (has("glas/gable") || has("lebensmittelkontakt")) return "food";
    if (has("spülmaschinen")) return "dishwasher";
    if (has("nicht mikrowellen")) return "noMicrowave";
    if (has("mikrowellen geeignet")) return "microwave";
    if (has("gefriergeeignet")) return "freezer";
    if (has("bpa")) return "bpa";
    if (/\bpp\b/.test(k)) return "pp";
    if (has("360") || has("100")) return "max";

    return "text";
  }

  /* ISO 3758 / GINETEX-Reihenfolge */
  var CARE_RANK = {
    wash30: 1, wash40: 1, wash60: 1, wash95: 1, washDelicate30: 1, washVeryDelicate30: 1,
    handwash: 1, noWash: 1, washText: 1,
    bleach: 2, noBleach: 2,
    tumble: 3, tumbleLow: 3, tumbleNormal: 3, noTumble: 3,
    iron110: 4, iron150: 4, iron200: 4, noIron: 4,
    dryclean: 5, drycleanGentle: 5, noDryclean: 5
  };

  function rankOf(key) {
    return CARE_RANK[key] || 9;
  }

  function sortCare(parts) {
    return parts
      .map(function (txt, index) {
        var key = getIconKey(txt);
        return { txt: txt, key: key, index: index, rank: rankOf(key) };
      })
      .sort(function (a, b) {
        return a.rank - b.rank || a.index - b.index;
      });
  }

  /* =========================================================
     Tooltip (nur für die Symbol-Darstellung)
  ========================================================= */

  function ensureTooltip() {
    var tip = document.getElementById("care-global-tooltip");
    if (tip) return tip;

    tip = document.createElement("div");
    tip.id = "care-global-tooltip";
    tip.setAttribute("aria-hidden", "true");
    tip.style.position = "fixed";
    tip.style.zIndex = "999999";
    tip.style.padding = "8px 10px";
    tip.style.fontSize = "12px";
    tip.style.lineHeight = "1.2";
    tip.style.background = "#3c424a";
    tip.style.color = "#fff";
    tip.style.borderRadius = "8px";
    tip.style.whiteSpace = "nowrap";
    tip.style.pointerEvents = "none";
    tip.style.boxShadow = "0 8px 24px rgba(0,0,0,.25)";
    tip.style.transform = "translate(-9999px,-9999px)";
    document.body.appendChild(tip);
    return tip;
  }

  function positionTooltip(tip, el) {
    var r = el.getBoundingClientRect();
    var pad = 8;

    tip.style.transform = "translate(0,0)";
    tip.style.visibility = "hidden";

    var tr = tip.getBoundingClientRect();

    var left = r.left + r.width / 2 - tr.width / 2;
    var top = r.top - tr.height - 10;

    if (top < pad) top = r.bottom + 10;
    left = Math.max(pad, Math.min(left, window.innerWidth - tr.width - pad));
    top = Math.max(pad, Math.min(top, window.innerHeight - tr.height - pad));

    tip.style.left = left + "px";
    tip.style.top = top + "px";
    tip.style.visibility = "visible";
  }

  function bindTooltipEvents() {
    if (window.__careTooltipBound) return;
    window.__careTooltipBound = true;

    var tip = ensureTooltip();
    var active = null;
    var isTouch = window.matchMedia("(hover: none)").matches;

    function show(el) {
      tip.textContent = el.getAttribute("aria-label") || "";
      active = el;
      positionTooltip(tip, el);
    }

    function hide() {
      active = null;
      tip.style.transform = "translate(-9999px,-9999px)";
    }

    document.addEventListener("pointerdown", function (e) {
      var el = e.target.closest(".care-icon");
      if (!el) {
        hide();
        return;
      }
      if (isTouch) {
        e.preventDefault();
        active === el ? hide() : show(el);
      }
    }, { passive: false });

    if (!isTouch) {
      document.addEventListener("pointerover", function (e) {
        var el = e.target.closest(".care-icon");
        if (el) show(el);
      });
      document.addEventListener("pointerout", function (e) {
        if (e.target.closest(".care-icon")) hide();
      });
    }

    document.addEventListener("focusin", function (e) {
      var el = e.target.closest && e.target.closest(".care-icon");
      if (el) show(el);
    });
    document.addEventListener("focusout", function (e) {
      if (e.target.closest && e.target.closest(".care-icon")) hide();
    });

    window.addEventListener("scroll", function () { active && positionTooltip(tip, active); }, true);
    window.addEventListener("resize", function () { active && positionTooltip(tip, active); });
  }

  /* =========================================================
     Render Pflegehinweise
  ========================================================= */

  function renderIcons(items, withText) {
    var html = items.map(function (item) {
      var src = iconByKey(item.key);
      var label = escapeHtml(item.txt);
      if (!src) {
        /* Kein passendes Symbol: bei "Symbole und Text" steht der Hinweis in der Liste,
           bei "Nur Symbole" wird er als Text in der Reihe ausgegeben */
        return withText ? "" : '<span class="care-icon-text">' + label + '</span>';
      }
      if (withText) {
        return '<span class="care-icon care-icon--static" aria-hidden="true">' +
          '<img src="' + src + '" width="32" height="32" loading="lazy" alt="">' +
          '</span>';
      }
      return '<button class="care-icon" type="button" aria-label="' + label + '">' +
        '<img src="' + src + '" width="32" height="32" loading="lazy" alt="">' +
        '</button>';
    }).join("");
    return html ? '<div class="care-icons">' + html + '</div>' : "";
  }

  function renderText(items) {
    return '<ul class="care-list">' + items.map(function (item) {
      return '<li>' + escapeHtml(item.txt) + '</li>';
    }).join("") + '</ul>';
  }

  function enhance(scope) {
    scope = scope || document;
    var mode = displayMode();
    var rows = scope.querySelectorAll(".accordion__content p");

    rows.forEach(function (p) {
      var strong = p.querySelector("strong");
      var field = p.querySelector("span.metafield-multi_line_text_field");

      if (!strong || !field) return;
      if (strong.textContent.trim().toLowerCase() !== "pflegehinweise") return;
      if (field.dataset.careEnhanced) return;

      var raw = field.textContent.trim();
      if (!raw) return;

      var parts = raw.split(/[,\n]/).map(function (x) { return x.trim(); }).filter(Boolean);
      var items = sortCare(parts);

      var html = "";
      if (mode === "icons") {
        html = renderIcons(items, false);
      } else if (mode === "icons_text") {
        html = renderIcons(items, true) + renderText(items);
      } else {
        html = renderText(items);
      }

      field.innerHTML = '<div class="care-block care-block--' + mode + '">' + html + '</div>';
      field.dataset.careEnhanced = "true";
    });
  }

  /* =========================================================
     Styles (mobile first, px statt rem wegen 62.5 % Root)
  ========================================================= */

  function injectStyles() {
    if (document.getElementById("care-style")) return;

    var s = document.createElement("style");
    s.id = "care-style";
    s.textContent = [
      ".care-block{display:block;margin-top:6px}",
      ".care-icons{display:flex;flex-wrap:wrap;align-items:center;gap:6px}",
      ".care-icon{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;padding:0;margin:0;border:0;background:none;box-shadow:none;cursor:default;-webkit-tap-highlight-color:transparent}",
      "button.care-icon{cursor:pointer}",
      ".care-icon img{display:block;width:32px;height:32px;object-fit:contain}",
      ".care-icon-text{font-size:13px;line-height:1.3}",
      ".care-icon:focus-visible{outline:2px solid #3c424a;outline-offset:2px;border-radius:4px}",
      ".care-list{margin:0;padding-left:18px;font-size:14px;line-height:1.5}",
      ".care-list li{margin:0}",
      ".care-block--icons_text .care-list{margin-top:8px}",
      "@media screen and (min-width:750px){.care-list{font-size:15px}}"
    ].join("");
    document.head.appendChild(s);
  }

  /* =========================================================
     Init
  ========================================================= */

  function init() {
    injectStyles();
    if (displayMode() === "icons") bindTooltipEvents();
    enhance(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

})();